import { Alert, Col, Row } from "reactstrap";
import PlansLayout from "../../layouts/PlansLayout";
import PlanCard from "../../components/Cards/PlanCard";
import { Fragment, useEffect, useState } from "react";
import { API_URL } from "../../utils/constants";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";

function PlansPage() {
  const { t } = useTranslation('plans');
  const [plansLoading, setPlansLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [coupon, setCoupon] = useState({});
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const premiumRequired = queryParams.has("premium_required");

  useEffect(() => {
    if(premiumRequired) {
      toast.warning("يجب عليك شراء رصيد إعلانات لتتمكن من إضافة إعلان.");
    }
  }, [premiumRequired]);

  const getPlans = () => {    
    setPlansLoading(true);

    fetch(API_URL+'/user/plans', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {
        setPlans(data.plans);
        setCoupon(data.coupon || {});
      }
      setPlansLoading(false);
    })
  }

  useEffect(() => {
    getPlans();
  }, []);

  return(
    <PlansLayout>
      <h4>{t('title')}</h4>
        
      {plansLoading ?
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      :
        <Fragment>
          {coupon && coupon.code &&
            <Alert color="success">
              <Trans
                ns="plans"
                i18nKey="coupon_alert"
                values={{
                  code: coupon.code,
                  percent: coupon.percentage
                }}
                components={{ strong: <strong /> }}
              />
            </Alert>
          }
          <Row>
            {plans?.length > 0 && plans.map((data, key) => {
              return(
                <Col md="4" key={key} className="mb-3">
                  <PlanCard 
                    plan={data} 
                  />
                </Col>
              );
            })}
          </Row>
        </Fragment>
      }
    </PlansLayout>
  );
}

export default PlansPage;